import { AbodeAggregateMarketConditions } from '@aloft/toolkit-shared';
import { Icon } from '@aloft/toolkit-sui';
import { useEffect } from 'react';
import { LoadingScreenSam } from '../../../components/LoadingScreen/LoadingScreenSam.tsx';
import { Flex } from '../../../summary/components/Flex.tsx';
import { TotalComparableSales } from './graphs/TotalComparableSales.tsx';
import { AbsorptionRate } from './graphs/AbsorptionRate.tsx';
import { MedianSalePrice } from './graphs/MedianSalePrice.tsx';
import { TotalComparableListings } from './graphs/TotalComparableListings.tsx';
import { MonthsOfHousingSupply } from './graphs/MonthsOfHousingSupply.tsx';
import { MedianDOM } from './graphs/MedianDOM.tsx';
import { useGetMarketAggregateDataAPI } from '../../../hooks/api/toolkitComponents.ts';
import { useAppDispatch } from '../../../redux/hooks.ts';
import { addMarketAggregateData } from '../../../redux/features/orderSlice.ts';
import { MedianListPrice } from './graphs/MedianListPrice.tsx';
import { MedianSalePriceToListPrice } from './graphs/MediaSalePricetoListPrice.tsx';

export const MarketConditionsGraphs = (
  {
    orderID,
    geoType,
    geoId,
    allMarketAggregateData,
  }: {
    orderID: string;
    geoType: string;
    geoId: string;
    allMarketAggregateData?: AbodeAggregateMarketConditions[];
  }
) => {
  const dispatch = useAppDispatch();
  const { data, isLoading, isError } = useGetMarketAggregateDataAPI({
    pathParams: { orderID },
    queryParams: {
      geoType,
      geoId,
    },
  });
  const marketAggregateData = data as AbodeAggregateMarketConditions;

  useEffect(() => {
    // Workaround to update Redux when new data is fetched
    if (!isLoading && marketAggregateData && !allMarketAggregateData?.find((data) => data.geoType === marketAggregateData.geoType && data.geoId === marketAggregateData.geoId)) {
      dispatch(addMarketAggregateData(marketAggregateData));
    }
  }, [marketAggregateData, allMarketAggregateData, dispatch, isLoading]);

  if (isLoading) {
    return <LoadingScreenSam overrideText="Loading market conditions..." />;
  }
  if (isError || !marketAggregateData || marketAggregateData.monthlyData.length === 0) {
    return <Flex alignItems="center" gap={2}><Icon icon="error-warning" color="error" /> Error loading market condition analysis data. Please try another filter or ZIP code</Flex>;
  }

  return (
    <Flex flexDirection="column" gap={6} marginBottom={6}>
      <TotalComparableSales data={marketAggregateData} />
      <AbsorptionRate data={marketAggregateData} />
      <TotalComparableListings data={marketAggregateData} />
      <MonthsOfHousingSupply data={marketAggregateData} />
      <MedianSalePrice data={marketAggregateData} />
      <MedianListPrice data={marketAggregateData} />
      <MedianSalePriceToListPrice data={marketAggregateData} />
      <MedianDOM data={marketAggregateData} />
    </Flex>
  )
};
